import React, {FC, useEffect, useState} from 'react';
import './express-help.scss';
import { IResultData } from './express-help.types';
import { Col, DatePicker, Form, Input, Modal, notification, Row, Space, Table } from 'antd';
import Button from 'mixins/ui/button/button';
import Link from 'antd/es/typography/Link';
import ResultModal from './modals/modal-result';
import {deleteResultById, getResultList, getResultTypeList, searchResult} from "/react4xp/parts/express-help/actions";

const ResultComponent: FC = (props: any) => {
  const [data, setData] = useState<IResultData[]>([]);
  const [editMode, setEditMode] = useState<boolean>(false);
  const [selectedObject, setSelectedObject] = useState<IResultData>();
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState(false);

  const [form] = Form.useForm();
  const { confirm } = Modal;

  const load = () => {
    setIsLoading(true);

    Promise.all([ getResultList(), getResultTypeList() ]).then(
        ([result, resultTypes]) => {
          if (result.data) {
            setData(result.data.map(x => ({
              ...x,
              resultType: resultTypes.data
                  && x.resultTypeId
                  && resultTypes.data.find(y => y.id === x.resultTypeId)?.resultTypeRu
            })));
          }
    }).finally(
        () => setIsLoading(false)
    );
  };

  const deleteOne = (id: number) => {
    confirm({
      title: 'Подтвердите действия удаления данных',
      onOk() {
        deleteResultById(id)
          .then(() => {
            notification['success']({
              message: 'Данные успешно удалены!',
            });
            load();
          })
          .catch(() => {
            notification['error']({
              message: 'Ошибка',
              description: 'Невозможно удалить запись',
            });
          })
          .finally(() => {});
      },
    });
  };

  const editResultType = (doc: any) => {
    setSelectedObject(doc);
    setIsModalOpen(true);
    setEditMode(true);
  };

  const handleOk = () => {
    setSelectedObject(null);
    setEditMode(false);
    setIsModalOpen(false);
    load();
  };

  const handleCancel = () => {
    setSelectedObject(null);
    setEditMode(false);
    setIsModalOpen(false);
  };

  const add = () => {
    setIsModalOpen(true);
    setEditMode(false);
    setSelectedObject(selectedObject);
  };

  const onActionClick = (key: string, doc: any) => {
    switch (key) {
      case 'EDIT':
        editResultType(doc);
        break;
      case 'DELETE':
        deleteOne(doc.id);
        break;
    }
  };

  const columnsQuestionnaire = [
    {
      title: 'ИД',
      dataIndex: 'externalResultId',
    },
    {
      title: 'Наименование на казахском языке',
      dataIndex: 'resultKk',
    },
    {
      title: 'Наименование на русском языке',
      dataIndex: 'resultRu',
    },
    {
      title: 'Наименование на английском языке',
      dataIndex: 'resultEn',
    },
    {
      title: 'Изменил',
      dataIndex: 'username',
    },
    {
      title: 'Тип результата',
      dataIndex: 'resultType',
    },
    {
      title: 'Действия',
      width: 180,
      render: (text, record) => (
        <div className="d-flex flex-column">
          <Link
            className="column-button"
            style={{ marginRight: 3 }}
            onClick={() => {
              onActionClick('DELETE', record);
            }}
          >
            Удалить
          </Link>

          <Link
            className="column-button"
            style={{ marginRight: 3 }}
            onClick={() => {
              onActionClick('EDIT', record);
            }}
          >
            Редактировать
          </Link>
        </div>
      ),
    },
  ];

  useEffect(() => {
    load();
  }, []);

  const onFinish = (values) => {
    searchResult(values).then((response) => {
      setData(response.data.content);
    });
  };

  const reset = () => {
    form.resetFields();
  };

  return (
    <div className="poll-screen">
      <h4 className="my-3">Результаты</h4>

      <Form
          form={form}
          layout="vertical"
          onFinish={onFinish}
          className="my-3"
      >
        <Row gutter={{ xs: 8, md: 16 }}>
          <Col xs={24} md={8}>
            <Form.Item
                name="username"
                label="Изменил"
            >
              <Input placeholder="Введите" />
            </Form.Item>
          </Col>
          <Col xs={24} md={8}>
            <Form.Item
                name="dateFrom"
                label="Дата изменения C"
            >
              <DatePicker picker="date" />
            </Form.Item>
          </Col>
          <Col xs={24} md={8}>
            <Form.Item
                name="dateTo"
                label="По"
            >
              <DatePicker picker="date" />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
                name="result"
                label="Наименование результата рус."
            >
              <Input placeholder="Введите" />
            </Form.Item>
          </Col>
        </Row>

        <Space wrap>
          <Button onClick={reset}>Сброс</Button>
          <Button
              type="primary"
              htmlType="submit"
              color="gold"
          >
            Поиск
          </Button>
        </Space>
      </Form>

      <Row gutter={{ xs: 24, md: 24 }} className="my-3" justify="space-between" >
        <Col>
          <h4 className="poll-screen-list">Список результатов</h4>
        </Col>
        <Col>
          <Button color="gold" onClick={add}>
            Создать результат
          </Button>
        </Col>
      </Row>

      <Table
          className="my-3"
          dataSource={data}
          columns={columnsQuestionnaire}
          loading={isLoading}
          pagination={{
            showSizeChanger: true,
          }}
      />

      <ResultModal
        isModalOpen={isModalOpen}
        handleOk={handleOk}
        handleCancel={handleCancel}
        editMode={editMode}
        selectedObject={selectedObject}
        user={props.user}
      />
    </div>
  );
};

export default ResultComponent;
